import React, { useState } from 'react';
import { Megaphone, EyeOff, Check, Loader2 } from 'lucide-react';
import { api } from '../lib/api';

export default function PublishToLedgerButton({ noticeId, initialPublic = false, onChange = () => {} }) {
  const [isPublic, setIsPublic] = useState(initialPublic);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const toggle = async () => {
    if (!noticeId) return;
    setErr(''); setBusy(true);
    try {
      const target = !isPublic;
      const path = target ? `/ledger/publish/${noticeId}` : `/ledger/unpublish/${noticeId}`;
      const r = await api.post(path);
      const next = !!r.data.public_ledger;
      setIsPublic(next);
      onChange(next);
    } catch (e) {
      setErr(e.response?.data?.detail || 'Action failed');
    } finally { setBusy(false); }
  };

  return (
    <div className="inline-flex flex-col items-end gap-1">
      <button
        onClick={toggle}
        disabled={busy || !noticeId}
        className={`btn-ghost text-xs inline-flex items-center gap-2 ${isPublic ? 'border-plai-teal text-plai-teal' : ''}`}
        data-testid="publish-to-ledger-btn"
        title={isPublic ? 'Currently public on the Ledger of Resistance' : 'Make this notice public on the Ledger of Resistance (anonymized)'}
      >
        {busy ? <Loader2 className="h-3 w-3 animate-spin" />
          : isPublic ? <><Check className="h-3 w-3" strokeWidth={2} /> On Ledger</>
          : <><Megaphone className="h-3 w-3" strokeWidth={1.5} /> Join The Resistance</>}
      </button>
      {err && <span className="font-body text-[10px] text-red-400" data-testid="publish-ledger-error">{err}</span>}
      {!err && (
        <span className="font-body text-[10px] tracking-wide text-white/40 max-w-[220px] text-right">
          {isPublic ? 'Public anonymized. Toggle to remove.' : 'Default is private. Opt-in to publish.'}
        </span>
      )}
    </div>
  );
}
